export const loginPageTranslations = {
  footer: {
    privacy_policy: { text: 'Privacy Policy', link: '#' },
    support: { text: 'Support', link: '#' },
  },
  messages: {
    logging_in: 'Redirecting...',
    link_expired: 'Link has expired. Please log in or try again.',
    forgot_password_success: {
      header: 'Check your email inbox',
      subheader:
        'We have sent you a link to reset your password.\nOpen it from your inbox to set a new password.\nDidn’t receive an email? Check your spam folder.',
    },
    first_connection_success: {
      header: 'Create your password',
      subheader: 'You have received an email with a link to create your password at %{email}.',
      note: 'Didn’t receive this email? Check your spam folder',
    },
    forgot_password: {
      header: 'Reset password',
      subheader: 'Enter your email address to request a password reset link',
      failed: 'Failed to send password reset email. Try again later or contact support.',
      failed_activation:
        'Failed to activate account. Verify code and email are correct or contact support.',
      cta_text: 'Reset password',
    },
    first_connection: {
      header: 'To get started, please identify yourself',
      subheader: {
        has_no_phonenumber: 'Enter your email address and company code',
        has_phonenumber: 'Enter your email address',
      },
    },
    change_password: {
      header: 'Change password',
      subheader: 'Enter your new password',
      failed: 'Failed to reset your password. Try again later or contact support.',
      weak_password: 'This password is easy to guess, please choose a stronger password.',
      weak_password_has_words: 'Your password can’t have words in it.',
      weak_password_has_consecutive_chars:
        'Your password can’t have more than two of the same character in a row.',
      disabled: 'Password reset is disabled. Please contact support.',
      description: {
        header: 'Your password of at least 12 characters must contain:',
        line1:
          'Letters: one uppercase and one lowercase letter (excluding proper nouns, common nouns, or sequences of keyboard characters)',
        line2: 'Numbers without a logical sequence (123456) or identical sequence (11111)',
        line3: 'One special character',
      },
      cta_text: 'Confirm',
    },
    landing: {
      header: {
        line1: 'Welcome to the AXA Business',
        line2: 'Savings space',
      },
      mlk_header: {
        line1: 'Welcome to the Malakoff',
        line2: 'Business Savings space',
      },
      first_connection: 'Get started',
      login: 'Sign in',
      footer: 'We are a regulated company.',
      footer_link: 'Learn more',
    },
    login: {
      header: 'Login',
      subheader: 'Enter your email and password',
    },
    verify_email: {
      header: 'Verify your email',
      subheader: 'We’ve sent you a magic link to log in',
      note: 'Open it in your email to access to your company dashboard',
    },
    verify_otp: {
      header: 'Enter confirmation code',
      subheaderSupport: 'Please contact support and enter the code they give you below.',
      subheaderEmail: 'We’ve sent a confirmation code to your email. Please enter it below.',
      subheaderAlternateEmail:
        "We've sent a confirmation code to your 2nd email for 2FA (%{alternateEmail}). Please enter it below.",
      subheaderSMS:
        'We’ve sent an SMS with confirmation code to your phone number. Please enter it below.',
      failed: 'Invalid confirmation code',
      expired: 'Confirmation code expired. Please try again.',
      testCode: 'Test code: %{code}',
    },
    add_alternate_email: {
      title: 'Add alternate email',
      description_add_email: 'Please add a 2nd email for 2FA by contacting AXA customer support.',
      description_support_phone:
        'You can call %{phoneNumber} between 8:30 AM and 6:00 PM (Paris time, CET/CEST).',
      description_contact_support:
        'If you are outside of these hours, please contact your company administrator for assistance.',
      back_to_login: 'Back to login',
    },
    verify_phone_number: {
      header: {
        code_and_phone: 'Add your mobile phone number and your company code',
        add: 'Add your phone number',
        verify: 'Confirm your phone number',
      },
      subheader: {
        code_and_phone:
          'Log in with your company code. Your mobile phone number is required to enhance the security of your transactions',
        add: 'Your phone number is required to enhance the security of your transactions',
        verify: 'If the number displayed below is incorrect, please contact AXA customer service',
      },
      contact_us: 'Contact us',
      cta_text: 'Confirm',
      failed: 'Failed to verify phone number',
    },
    contact_us: {
      header: 'Contact us',
      content:
        'Please contact customer support at 09 70 80 85 95 to obtain a company code that will allow you to access your space.',
      cta_text: 'Continue',
    },
    form: {
      email_placeholder: 'Email',
      password_placeholder: 'Password',
      external_code_enterprise_placeholder: 'Enterprise code',
      external_code_enterprise: {
        helper_dialog: {
          title: 'Company code',
          text: "Your company code has been provided to you by letter or by phone via AXA customer service. Haven't received the code? Please contact customer support at 09 70 80 85 95.",
        },
      },
      confirm_password_placeholder: 'Confirm password',
      phone_number_placeholder: 'Mobile phone number',
      remember_me: 'Remember me',
      forgot_password: 'Forgot your password?',
      first_connection: 'First connection?',
      errors: {
        invalid_type: 'Invalid input type',
        required: 'Required',
        email_format: 'Invalid email format',
        invalid_credentials: 'Invalid email or password',
        password_length_min: 'Password must be at least 12 characters',
        password_length_max: 'Password must be at most 128 characters',
        password_req_uppercase: 'Password must contain an upper case letter',
        password_req_lowercase: 'Password must contain a lower case letter',
        password_req_number: 'Password must contain a number',
        password_req_symbol: 'Password must contain a special character',
        password_mismatch: 'Passwords must be the same',
        phoneNumber_format: 'Invalid phone number',
        phoneNumber_tooLong: 'Phone number is too long',
        phoneNumber_tooShort: 'Phone number is too short',
        phoneNumber_invalidCountryCode: 'Invalid country code',
      },
      cta_text: 'Next',
    },
  },
};
